import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  TextField,
  Checkbox,
  FormControlLabel,
  Snackbar,
  Grid,
} from "@mui/material";
import Alert from "@mui/material/Alert"; // Import Alert for Snackbar
import useFirestore from "../../../../config/fireBaseHook"; // Import useFirestore
import ModalDialogTitle from "../../../common/ModalDialogTitle";
import ModalActions from "../../../common/ModalActions";

const Add = ({ onRecordAdded }) => {
  const { addData } = useFirestore("ShellRequestStatus"); // Specify collection name
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const [formData, setFormData] = useState({
    Status: "",
    Active: "No",
    Approval_Page_Option: 0,
    Dropdown_Option: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    if (name === "Active") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: checked ? "Yes" : "No",
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: checked ? -1 : 0,
      }));
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await addData(formData); // Use Firestore hook's addData
      setLoading(false);
      setSnackbarMessage("Record has been added successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      setFormData({
        Status: "",
        Active: "No",
        Approval_Page_Option: 0,
        Dropdown_Option: "",
      });
      setOpen(false);
      if (onRecordAdded) onRecordAdded(); // Call the callback function
    } catch (error) {
      console.error("Error adding record:", error);
      setLoading(false);
      setSnackbarMessage(`Error adding record: ${error.message}`);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <div>
      <Button
        variant="contained"
        color="success"
        onClick={() => setOpen(true)}
        sx={{ marginBottom: "10px", color: "white" }}
      >
        Add Shell Status
      </Button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <ModalDialogTitle onClose={() => setOpen(false)}>
          Add Shell Status
        </ModalDialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Status"
                name="Status"
                value={formData.Status}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.Active === "Yes"}
                    onChange={handleCheckboxChange}
                    name="Active"
                  />
                }
                label="Active"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.Approval_Page_Option === -1}
                    onChange={handleCheckboxChange}
                    name="Approval_Page_Option"
                  />
                }
                label="Approval Page Option"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Dropdown Option"
                name="Dropdown_Option"
                value={formData.Dropdown_Option}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <ModalActions onSave={handleSubmit} saving={loading} />
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
          variant="filled"
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default Add;
